import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/field";
import { JollyTextField } from "@/components/ui/textfield";
import { updateCreateEditNewsAlert } from "@/store/news-alerts/news-alerts.actions";
import useNewsAlertsStore from "@/store/news-alerts/news-alerts.slice";
import { useEffect, useRef, useState } from "react";

const CreateEditNewsAlertModalDetails = () => {
  const createEditNewsAlert = useNewsAlertsStore(
    (state) => state.createEditNewsAlert,
  );
  const { alertName, description } = createEditNewsAlert;
  const [showDescription, setShowDescription] = useState(
    Boolean(description.length),
  );
  const descriptionTextareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (showDescription) {
      if (descriptionTextareaRef?.current) {
        descriptionTextareaRef.current.focus();
      }
    } else {
      setShowDescription(false);
    }
  }, [showDescription]);

  return (
    <div className="flex flex-col gap-1">
      <Label aria-label="details-label" className="text-sm text-gray-700">
        Details
      </Label>
      <JollyTextField
        size="sm"
        label="Alert Name"
        className="text-xs text-gray-700"
        placeholder="Ex: Newsfeed + Saved View"
        value={alertName}
        onChange={(value) =>
          updateCreateEditNewsAlert({
            ...createEditNewsAlert,
            alertName: value,
          })
        }
      />
      {showDescription ? (
        <div className="pt-2">
          <JollyTextField
            size="sm"
            ref={descriptionTextareaRef}
            className="text-xs text-gray-700"
            label=""
            placeholder="Add a description..."
            rows={3}
            textArea
            value={description}
            onChange={(value) =>
              updateCreateEditNewsAlert({
                ...createEditNewsAlert,
                description: value,
              })
            }
          />
          <Button
            variant="ghost"
            size="link"
            className="text-gray-700 w-fit text-xs px-2"
            onPress={() => {
              updateCreateEditNewsAlert({
                ...createEditNewsAlert,
                description: "",
              });
              setShowDescription(false);
            }}
          >
            Remove description
          </Button>
        </div>
      ) : (
        <Button
          variant="ghost"
          size="link"
          className="text-gray-700 w-fit text-xs px-4 py-1"
          onPress={() => {
            setShowDescription(true);
          }}
        >
          Add a description
        </Button>
      )}
    </div>
  );
};

export default CreateEditNewsAlertModalDetails;
